export enum InputState {
  Hidden = 'hidden',
  Shown = 'show',
}

export enum ConfigMode {
  Hidden = 'hidden',
  Edit = 'edit',
  ViewOnly = 'viewonly',
}

export enum ConversationRole {
  Assistant = 'assistant',
  User = 'user',
  System = 'system',
}

export enum MessagePartType {
  Text = 'text',
  Image = 'image',
}

export enum PartFormat {
  Plain = 1,
  Table = 2,
  CodeSnippet = 3,
}

export enum ModelMode {
  Hidden = 1,
  ViewOnly = 2,
  Edit = 3,
}

export enum Tab {
  Chat = 'chat',
  Settings = 'settings',
}

export interface IConfigs {
  inputState: InputState,
  chatInstructions?: string,
  settingsInstructions?: string,
  inputDefaultValue?: string,
  selectedTab: Tab,
  maxConversationMessages: number;
}

export interface IPrompt {
  id: string,
  prompt: string,
  displayPrompt: string;
}

export type TextMessagePart = {
  type: MessagePartType.Text,
  content: {
    text: string;
  };
};

export type ImageMessagePart = {
  type: MessagePartType.Image,
  content: {
    url: string;
  };
};

export type MessagePart = TextMessagePart | ImageMessagePart;

export type Message = {
  role: ConversationRole;
  parts: MessagePart[];
  hasError?: boolean;
};

export interface IModelConfig {
  key: string;
  value: string;
  mode: ConfigMode;
}

export enum Setting {
  Temperature = 'temperature',
  ModelVersion = 'modelVersion',
}

export interface ISlider {
  title: string,
  description: string,
  step: number,
  maxValue: number,
  minValue: number,
}

export interface IAIChatData {
  configs: IConfigs,
  conversation: {
    conversationId: string,
    messages: Message[],
  };
  modelConfigs: IModelConfig[],
  prompts: IPrompt[];
}

export enum ErrorStatusCodes {
  InternalServerError = 500,
  PromptTooLong = 413,
  LimitReached = 429,
  InappropriateContent = 422,
  ChatGptError = 488,
  NotOwned = 466,
}

export enum TrackingWarningMessages {
  PromptTooLong = 'PROMPT TOO LONG',
  NoInternetConnection = 'NO INTERNET CONNECTION',
  LimitReached = 'LIMIT REACHED',
  SomethingWentWrong = 'SOMETHING WENT WRONG',
  AiError = 'AI ERROR',
}

export interface Settings {
  temperature: {
    title: string;
    description: string;
    step: number;
    maxValue: number;
    minValue: number;
    componentTypeId: number;
  };
  model: {
    title: string;
    description: string;
    versions: string[];
    componentTypeId: number;
  };
}
